var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 72,
  r: 5,
  fill: "none",
  fillRule: "evenodd",
  stroke: "#9DAFBA",
  strokeWidth: 2,
  transform: "translate(-126 -66)"
})));
export default SvgCircle;